import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EMPTY_FORM = {
    name: "",
    phone: "",
    email: "",
    project_type: "New Build",
    message: "",
};

export function useContactForm() {
    const [form, setForm] = useState({ ...EMPTY_FORM });
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [errorMsg, setErrorMsg] = useState("");

    const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const reset = () => setStatus("idle");

    const submit = async (e) => {
        e.preventDefault();
        setStatus("loading");
        setErrorMsg("");

        // Send to backend (saves to DB) AND FormSubmit (emails info@) in parallel.
        // Form succeeds if at least one channel lands so a lead is never lost.
        const dbCall = axios.post(`${API}/contact`, form);
        const emailCall = axios.post(
            "https://formsubmit.co/ajax/info@brazierdevelopments.com.au",
            {
                name: form.name,
                email: form.email,
                phone: form.phone,
                project_type: form.project_type,
                message: form.message,
                _subject: `New website enquiry — ${form.name} (${form.project_type})`,
                _replyto: form.email,
                _template: "table",
            },
            { headers: { "Content-Type": "application/json", Accept: "application/json" } }
        );

        const [dbResult, emailResult] = await Promise.allSettled([dbCall, emailCall]);

        if (dbResult.status === "rejected" && emailResult.status === "rejected") {
            setStatus("error");
            const err = dbResult.reason;
            setErrorMsg(
                err?.response?.data?.detail?.[0]?.msg ||
                    err?.response?.data?.detail ||
                    "Something went wrong. Please call us or try again."
            );
            return;
        }

        setStatus("success");
        setForm({ ...EMPTY_FORM });
    };

    return { form, status, errorMsg, update, submit, reset };
}
